import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    IconClose,
    IconWarningType
} from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';

import './styles.scss';


const DisclaimerBanner = ({ text = '' }) => {
    const [showDisclaimer, setShowDisclaimer] = useState(true);
    return showDisclaimer ?
        <div className='general-disclaimer-container'>
            <div className='type-icon'>
                <IconWarningType width={24} height={24} color={colors.orangePeel} />
            </div>
            <div className='disclaimer-text'>
                {text}
            </div>
            <div className='close-icon'>
                <button
                    type='button'
                    className='disclaimer-close-button'
                    onClick={() => setShowDisclaimer(false)}
                    aria-label='Close disclaimer'
                >
                    <IconClose
                        color={colors.black}
                        strokeWidth='6'
                    />
                </button>
            </div>
        </div> : null;
};

DisclaimerBanner.propTypes = {
    text: PropTypes.string
};

export default DisclaimerBanner;
